module.exports = __webpack_public_path__ + "img/google-meet.9aab0046.svg";